import React, { useEffect, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import ClipLoader from 'react-spinners/ClipLoader';
import Table from 'components/Table';
import paths from 'pages/Router/paths';
import NavSearch from 'components/Layout/NavSearch';
import { contactOptions } from 'components/options';
import { useFormatDate } from 'hooks';
import { sortDate, sortDate2 } from 'utils';
import { Timestamp } from 'firebase/firestore';
import { getSubscriptions } from 'lib/subscription';

export default function Subscriptions() {
  const [search, setSearch] = useState();
  const [loading, setLoading] = useState(true);
  const [subscriptionList, setSubscriptionList] = useState([]);
  const { isAdmin } = useSelector(
    (state) => ({
      isAdmin: state.auth.userData.isAdmin,
    }),
    shallowEqual,
  );
  const fetchSubscription = async () => {
    setLoading(true);
    const result = await getSubscriptions();
    setLoading(false);
    setSubscriptionList(result);
  };
  useEffect(() => {
    if (isAdmin) {
      fetchSubscription();
    }
  }, [isAdmin]);

  const redirect = !isAdmin && <Navigate to={paths.ROOT} />;

  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
    },
    {
      Header: 'Customer Name',
      accessor: 'customerName',
    },
    {
      Header: 'Email',
      Cell: ({ row }) => row.original.email,
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ row }) => row.original.status.toUpperCase(),
    },
    {
      Header: 'Created At',
      accessor: 'created',
      sortType: sortDate2,
      Cell: ({ row }) => (
        <small className="has-text-grey is-abbr-like">
          {row.original.created instanceof Timestamp &&
            useFormatDate(row.original.created.toDate(), {
              weekday: 'short',
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })}
        </small>
      ),
    },
    {
      Header: 'Stripe Link',
      accessor: 'stripeLink',
      Cell: ({ row }) => (
        <a href={row.original.stripeLink} target="_blank">
          View
        </a>
      ),
    },
  ];

  const data = search
    ? subscriptionList.filter((el) => {
        const clonedElem = {
          status: el.status,
          customerName: el.customerName,
          email: el.email,
          id: el.id,
        };
        return Object.values(clonedElem).some((field) =>
          field && field.toString().toLowerCase().includes(search.toLowerCase()),
        );
      })
    : subscriptionList;
  console.log(subscriptionList);
  return (
    <>
      {redirect}

      <Card>
        <Card.Header>
          <div className="d-flex flex-row align-items-center">
            <Card.Title as="h5">Manage Subscriptions </Card.Title>
            <NavSearch handleChange={setSearch} />
          </div>
        </Card.Header>
        <Card.Body>
          <div className="b-table">
            {loading ? (
              <ClipLoader />
            ) : (
              <Table
                columns={columns}
                data={data}
                style={{
                  overflowX: 'auto',
                  width: '100%',
                  display: 'block',
                }}
              />
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
}
